// For the Custom Gift card page inputs form submitions

document.addEventListener("DOMContentLoaded", function () {
  const productForm = document.querySelector('product-form form');
  if (!productForm) return;
  const submitBtn = document.querySelector('.shopify-payment-button__button');
  if (!submitBtn) return;
  
  submitBtn.addEventListener("click", function (e) {
    const requiredFields = productForm.querySelectorAll(".gift-required");
    let valid = true;

    requiredFields.forEach(field => {
      if (!field.value.trim()) {
        valid = false;
        field.classList.add("error");
        field.setAttribute("placeholder", "empty field");
      } else {
        field.classList.remove("error");
        field.removeAttribute("placeholder");
      }
    });

    // const emailField = productForm.querySelector(".gift-email");
    // if (emailField) {
    //   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    //   if (!emailRegex.test(emailField.value.trim())) {
    //     valid = false;
    //     emailField.classList.add("error");
    //     emailField.setAttribute("placeholder", "please enter a valid email");
    //   }
    // }

    if (!valid) {
            e.preventDefault();
      e.stopImmediatePropagation();
      return false;
    }

  }, true);

});
